import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SITE } from "@/lib/site";
import Reveal from "@/components/Reveal";
import WhatsAppIcon from "@/components/WhatsAppIcon";

export const FinalCTA = () => (
 <section className="bg-white" data-testid="final-cta">
 <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-16 md:py-24">
 <Reveal>
 <div className="relative rounded-[32px] overflow-hidden border border-[#EAEAEA] bg-[#FEFCF3] p-10 md:p-16">
 {/* Decorative accents sit purely in corners, behind content */}
 <div
 className="absolute top-0 right-0 w-40 h-40 md:w-56 md:h-56 rounded-full bg-[#FDD805] translate-x-1/3 -translate-y-1/3 opacity-90 pointer-events-none"
 aria-hidden
 />
 <div
 className="absolute bottom-0 left-0 w-28 h-28 md:w-40 md:h-40 rounded-full border-[6px] border-[#FDD805] -translate-x-1/2 translate-y-1/2 opacity-80 pointer-events-none"
 aria-hidden
 />
 <div
 className="absolute top-6 left-8 h-1.5 w-14 bg-[#FDD805] rounded-full pointer-events-none"
 aria-hidden
 />

 {/* Content */}
 <div className="relative z-10 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
 <div className="md:col-span-8">
 <div className="text-[11px] uppercase tracking-[0.24em] font-bold text-[#4A4A4A]">
 Final word
 </div>
 <h2 className="mt-4 font-display text-[36px] md:text-[60px] leading-[1.02] font-black tracking-tight text-[#0F1115]">
 Talk first. <br />
 Decide with <span className="hl-yellow">clarity</span>.
 </h2>
 <p className="mt-5 text-[16px] md:text-[18px] text-[#1C1F26] max-w-xl leading-relaxed">
 Before choosing only on price, speak with someone who
 understands what First-Time Founders truly need.
 </p>
 </div>
 <div className="md:col-span-4 flex flex-col gap-3">
 <a
 href={SITE.whatsappUrl}
 target="_blank"
 rel="noreferrer"
 className="bg-[#25D366] text-white rounded-full px-7 py-4 font-bold text-[15px] inline-flex items-center justify-center gap-2 hover:bg-[#1EBE57] hover:-translate-y-0.5 transition-all"
 data-testid="final-cta-whatsapp"
 >
 <WhatsAppIcon size={18} /> Chat
 </a>
 <Link
 to="/contact"
 className="bg-white text-[#0F1115] border-2 border-[#0F1115] rounded-full px-7 py-3.5 font-bold text-[15px] inline-flex items-center justify-center gap-2 hover:bg-[#0F1115] hover:text-white transition-colors"
 data-testid="final-cta-enquiry"
 >
 Send Enquiry <ArrowRight size={16} />
 </Link>
 </div>
 </div>
 </div>
 </Reveal>
 </div>
 </section>
);

export default FinalCTA;
